export default __webpack_public_path__ + "static/media/non-aes.ea261783.svg";